import { Helmet } from "react-helmet-async";

const Content = () => {
  return (
    <>
      <Helmet>
        <title>学習コンテンツ管理</title>
      </Helmet>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6 mb-4">
                    <div className="card border-primary">
                      <div className="card-body text-center">
                        <i className="fas fa-microphone fa-3x text-primary mb-3"></i>
                        <h5 className="card-title">ディクテーション管理</h5>
                        <p className="card-text">
                          ディクテーションのコース、カテゴリ、レッスンを管理します。
                        </p>
                        <div className="d-flex flex-column gap-2">
                          <a href="/content/dictation-courses" className="btn btn-primary">
                            <i className="fas fa-book me-2"></i>
                            コース管理
                          </a>
                          <a href="/content/sentences" className="btn btn-outline-primary">
                            <i className="fas fa-comment me-2"></i>
                            センテンス管理
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="col-md-6 mb-4">
                    <div className="card border-success">
                      <div className="card-body text-center">
                        <i className="fas fa-spell-check fa-3x text-success mb-3"></i>
                        <h5 className="card-title">単語・熟語管理</h5>
                        <p className="card-text">
                          単語・熟語のコース、パート、レッスンを管理します。
                        </p>
                        <div className="d-flex flex-column gap-2">
                          <a href="/content/word-courses" className="btn btn-success">
                            <i className="fas fa-book me-2"></i>
                            コース管理
                          </a>
                          <a href="/content/words" className="btn btn-outline-success">
                            <i className="fas fa-spell-check me-2"></i>
                            単語・熟語管理
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="row">
                  <div className="col-12">
                    <div className="alert alert-info">
                      <h6 className="alert-heading">
                        <i className="fas fa-info-circle me-2"></i>
                        使用方法
                      </h6>
                      <ul className="mb-0">
                        <li><strong>ディクテーション:</strong> コース → カテゴリ → レッスンの順で作成してください。</li>
                        <li><strong>単語・熟語:</strong> コース → パート → レッスンの順で作成してください。</li>
                        <li>表示順は学習者に表示される順番を決定します。</li>
                        <li>削除する際は、子要素（カテゴリ、パート、レッスン）がないことを確認してください。</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Content;